module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_null@2x.e26eb509.png";